import WLPresetsJson from '../../../../../../meta/WLPresets.json';

let WLPresetsData = WLPresetsJson;

WLPresetsData = WLPresetsData.map(item => ({ ...item, name: item.name.trim() })); // elimina espacios exteriores que provocan errores

export const WLPresets = WLPresetsData;